<template lang="pug">
  v-simple-table
    tbody
      MetadataRow(label="Owning Department") {{data.owning_department}}
      MetadataRow(label="Publish Date") {{dateFormat(data.publish_date)}}
      MetadataRow(
        v-if="data.s3_details && data.s3_details.LastModified"
        label="Data Last Refreshed"
      ) {{dateFormat(data.s3_details.LastModified)}}
      MetadataRow(label="Update Frequency") {{getFrequency(data.update_frequency)}}
      MetadataRow(label="Collection") {{data.collection ? data.collection.title : 'Not Part of a Collection'}}
</template>

<script>
import moment from "moment";
import MetadataRow from "@/components/MetadataRow.vue";

export default {
  props: {
    data: Object
  },
  components: {
    MetadataRow
  },
  methods: {
    getFrequency(frequency) {
      if (frequency === "MultipleTimesPerDay") {
        return "Multiple Times Per Day";
      } else if (frequency === "DataOwnersDiscretion") {
        return "Data Owners Discretion";
      } else {
        return frequency;
      }
    },

    dateFormat(date) {
      if (date) return moment(date).format("LLL");
      else return date;
    }
  }
};
</script>
